import React from 'react';
import { Route } from 'react-router-dom';
import LoginScreen from '../screens/LoginScreen';
import LogoutScreen from '../screens/LogoutScreen';
import DashboardScreen from '../screens/DashboardScreen';
import * as ROUTES from '../constants/routes';
import SignUpScreen from '../screens/SignUpScreen';
import ForgotPasswordScreen from '../screens/ForgotPasswordScreen';
import ResetPasswordScreen from '../screens/ResetPasswordScreen';
import MarketOnBoardScreen from '../screens/MarketOnBoardScreen';

function AuthRoutes() {
  return (
    <>
      <Route path={ROUTES.LOGIN} exact component={() => <LoginScreen />} />
      <Route path={ROUTES.SIGNUP} exact component={() => <SignUpScreen />} />
      <Route
        path={ROUTES.FORGOT_PASSWORD}
        exact
        component={() => <ForgotPasswordScreen />}
      />
      <Route
        path={ROUTES.MARKET_ONBOARD_COMPANY}
        exact
        component={() => <MarketOnBoardScreen />}
      />
      <Route
        path={ROUTES.NEW_PASSWORD}
        exact
        component={() => <ResetPasswordScreen />}
      />
      <Route
        path={ROUTES.DASHBOARD}
        exact
        component={() => <DashboardScreen />}
      />
      <Route path={ROUTES.LOGOUT} exact component={() => <LogoutScreen />} />
      <Route path="/" exact component={() => <LoginScreen />} />
    </>
  );
}

export default AuthRoutes;
